import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import { useTranslate } from "ra-core";
import React from "react";
import { useHistory } from "react-router-dom";
import SendEmailIcon from "../../../assets/icons/send-email.png";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 667,
    overflow: "hidden",
    margin: "0 auto",
    paddingTop: 50,
    borderRadius: "12px",
    root: {
      overflow: "hidden",
    },
  },
  dialogPaper: {
    borderRadius: "12px",
  },
  helperText: {
    color: theme.red,
  },
  title: {
    fontSize: 30,
    color: theme.orange,
  },
  content: {
    fontSize: 16,
    color: theme.black,
  },
  paper: {
    margin: 0,
    width: 445,
    maxWidth: 360,
  },

  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
    overflow: "hidden",
  },

  dialogAction: { width: "100%", padding: 0 },
  logo: { padding: "40px 0 20px" },
  button: {
    width: "100%",
    backgroundColor: theme.orange,
    color: theme.white,
    fontSize: 24,
    borderRadius: 0,
    padding: 0,
    marginTop: 10,
  },
  checkEmailText: {
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: 20,
    color: theme.orange,
  },
  emailText: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 18,
    color: theme.darkGray,
  },
}));
function SenEmailPopup({ open, onClose, maskedEmail, username, refCode }) {
  const classes = useStyles();
  const history = useHistory();
  const translate = useTranslate();
  return (
    <Dialog
      className={classes.allContainer}
      classes={{ root: classes.allContainer, paper: classes.dialogPaper }}
      open={open}
      onClose={onClose}
    >
      <Paper classes={{ root: classes.paper }}>
        <DialogContent classes={{ root: classes.dialogContent }}>
          <img
            alt="send-email-icon"
            className={classes.logo}
            src={SendEmailIcon}
          />
          <Typography className={classes.checkEmailText}>
            {translate("ra.text.forgotPassword.checkYourEmail")}
          </Typography>
          <Typography className={classes.emailText}>
            {translate("ra.text.forgotPassword.sentOtp")}
          </Typography>
          <Typography className={classes.emailText}>
            {maskedEmail ? `(${maskedEmail})` : ""}
          </Typography>
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogAction }}>
          <Button
            variant="contained"
            // classesName={classes.button}
            classes={{ contained: classes.button }}
            onClick={() => {
              onClose();
              history.push({
                pathname: "/otp",
                state: {
                  maskedEmail: maskedEmail,
                  refCode: refCode,
                  username: username,
                },
              });
            }}
          >
            {translate("ra.action.ok")}
          </Button>
        </DialogActions>
      </Paper>
    </Dialog>
  );
}

export default SenEmailPopup;
